import React from 'react'
import { Button, Grid, InputBase } from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'

function ItemObservations({ open, item, handleClose, onSave, disabled }) {
  const classes = filterStylesComponents()
  const [observations, setObservations] = React.useState('')

  React.useEffect(() => {
    if (open) setObservations(item?.observations || '')
  }, [open, item?.observations])

  const handleSubmit = e => {
    e.preventDefault()

    onSave(observations)
    handleClose()
  }

  return (
    <BaseFilterModal
      open={open}
      title="Observações do Item"
      hiddenHelpButton
      handleOpen={handleClose}
    >
      <Grid item xs={12} style={{ width: '320px' }}>
        <form style={{ width: '100%', height: '100%' }} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputBase
                name="observations"
                value={observations}
                onChange={event => setObservations(event.target.value)}
                placeholder="Observações do item..."
                fullWidth
                multiline
                disabled={disabled}
                autoFocus
                inputProps={{
                  style: {
                    minHeight: '150px',
                    maxHeight: '200px',
                  },
                }}
                style={{
                  borderRadius: '15px',
                  border: `1px solid ${colors.graylight}`,
                  minHeight: '150px',
                  maxHeight: '200px',
                  padding: '12px',
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                type="button"
                onClick={handleClose}
                className={classes.btnMoreFilters}
              >
                Cancelar
              </Button>

              <Button
                type="submit"
                className={classes.btnAdd}
                disabled={disabled}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}

export default React.memo(ItemObservations)
